module.exports = __webpack_public_path__ + "media/images/about__join-the-team-sm-8239edd7dc3b8dbedccc72f5f1fec6a7.jpg";